import React from "react";
import { useSiteConfig } from "../contexts/SiteConfigContext";

export default function SiteMarquee() {
  const { config } = useSiteConfig();
  const m = config.marquee;

  if (!m?.enabled || !m?.text) return null;

  // Durée en secondes basée sur la vitesse (plus speed est grand = plus rapide)
  const duration = Math.max(10, Math.round(300 / (m.speed || 40))) + "s";

  return (
    <div
      className="site-marquee"
      style={{ background: m.bg || "#1B4F9E", color: m.color || "#fff" }}
    >
      <div className="site-marquee__track" style={{ animationDuration: duration }}>
        <span>{m.text}&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;{m.text}</span>
      </div>

      <style>{`
        .site-marquee {
          width: 100%;
          overflow: hidden;
          padding: 8px 0;
          font-size: 0.88rem;
          font-weight: 500;
          letter-spacing: 0.02em;
          position: relative;
          z-index: 99;
        }
        .site-marquee__track {
          display: inline-block;
          white-space: nowrap;
          animation: scrollMarquee linear infinite;
        }
        @keyframes scrollMarquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .site-marquee__track { animation: none; }
        }
      `}</style>
    </div>
  );
}
